import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAnalyticsFilters } from '../../../../contexts/AnalyticsFiltersContext';
import { getMockDailyActivity, getMockTutorUsageStats } from '../../../../mocks/mockTutorUsageData';

import type { TFunction } from 'react-i18next';
import type { DailyActivity, TutorUsageStats } from '../../../../mocks/mockTutorUsageData';

type UseTutorUsageSectionReturn = {
  dailyActivity: DailyActivity[] | null;
  isMockMode: boolean;
  stats: TutorUsageStats | null;
  t: TFunction;
};

function useTutorUsageSection(): UseTutorUsageSectionReturn {
  const { isMockMode } = useAnalyticsFilters();
  const { i18n, t } = useTranslation(['chatbot']);

  const stats = useMemo<TutorUsageStats | null>(() => {
    if (!isMockMode) return null;
    return getMockTutorUsageStats();
  }, [isMockMode]);

  const dailyActivity = useMemo<DailyActivity[] | null>(() => {
    if (!isMockMode) return null;
    return getMockDailyActivity(i18n.language);
  }, [isMockMode, i18n.language]);

  return { dailyActivity, isMockMode, stats, t };
}

export default useTutorUsageSection;
